import {
  useV2GetServiceByIdQuery,
  V2ProductResource,
  V2SubserviceResource,
} from "@generated";
import { Service, Subservice, Product } from "../types";

const useGetServiceById = (id) => {
  let customError: string | null = null; // Declare customError

  const { data, error, isLoading, refetch, isFetching } =
    useV2GetServiceByIdQuery({
      id,
      include: [
        "resource",
        "phase",
        "service-category",
        "subservices",
        //@ts-ignore
        "subservices.resource",
        "products",
      ],
    });

  let serviceData: Service | undefined = undefined;

  if (data?.data) {
    try {
      const phaseId = data.data?.relationships?.phase?.data?.id;
      const categoryId =
        data.data?.relationships?.["service-category"]?.data?.id;
      const sku = data.data?.attributes?.sku;
      const resource = data.data?.relationships?.resource?.data?.id;
      const hours = data.data?.attributes?.["suggested-hours"];
      const tags = data.data?.attributes?.["tag-list"]?.map((tag) => {
        return { value: tag, label: tag };
      });

      let subservices: Subservice[] = [];

      data.data.relationships?.subservices?.data?.forEach((subservice) => {
        const sub = data?.included?.find(
          (item) => item.id == subservice.id && item.type === "subservices"
        ) as V2SubserviceResource | undefined;
        if (sub?.id && sub?.attributes?.state !== "deleted") {
          subservices.push({
            id: String(sub.id),
            name: sub.attributes.name,
            quantity: Number(sub.attributes?.quantity || 0),
            resource: String(sub?.relationships?.resource?.data?.id || ""),
            hours: sub.attributes?.["suggested-hours"]
              ? String(sub.attributes?.["suggested-hours"])
              : "",
            position: sub.attributes?.position || 0,
            languages: sub.attributes?.languages || {},
            "service-description":
              sub.attributes?.["service-description"] || "",
            hasAdvancedPricing:
              sub.attributes?.["custom-service-price?"] ||
              sub.attributes?.["custom-service-cost?"] ||
              sub.attributes?.["custom-hours?"] ||
              false,
          });
        }
      });

      let products: Product[] = [];

      data.data.relationships?.products?.data?.forEach((product) => {
        const p = data?.included?.find(
          (item) => item.id == product.id && item.type === "products"
        ) as V2ProductResource | undefined;
        if (p?.id) {
          products.push({
            id: String(p.id),
            name: p.attributes?.name || "",
            mfrPart: p.attributes?.["manufacturer-part-number"] || "",
            sku: p.attributes?.sku || "",
            price: p?.attributes?.["unit-price"]
              ? String(p.attributes["unit-price"])
              : "",
          });
        }
      });

      const attributes = data.data?.attributes;

      serviceData = {
        id: String(data.data.id),
        name: attributes.name,
        phase: phaseId ? String(phaseId) : "",
        category: categoryId ? String(categoryId) : "",
        sku: sku ? String(sku) : "",
        resource: resource ? String(resource) : "",
        hours: hours ? String(hours) : "",
        teams:
          attributes?.teams?.map((t) => {
            return { value: t?.id || "", label: t?.name || "" };
          }) || [],
        tags: tags || [],
        frequency: attributes?.["payment-frequency"] || "",
        subservices: subservices.sort((a, b) => a.position - b.position),
        products,
        languages: attributes?.languages || {},
        "service-description": attributes?.["service-description"] || "",
        hasAdvancedPricing:
          attributes?.["custom-service-price?"] ||
          attributes?.["custom-service-cost?"] ||
          attributes?.["custom-hours?"],
        guidance: attributes?.guidance || "",
        //@ts-ignore
        variables: attributes?.variables || [],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    serviceData,
    isLoading,
    error: error ?? customError,
    refetch,
    isFetching,
  };
};
export default useGetServiceById;
